import { debug } from "console";
import { ModuleType } from "../constants/enums/module-type-enum";
import { PermissionType } from "../constants/enums/permission-type-enum";
import userTypeEnum from "../constants/enums/user-type-enum";
import authStore from "../core/stores/auth-store";
import preferenceStore from "../core/stores/preferences-store";
import { IRoleVM } from "../models/response/IRoleResponse";
import RoutesConstants from "../shared-components/routes/routes-constants";
import { getIsTenantAccessFromLocalStorage, getTenantAccessFromLocalStorage, getTokenFromLocalStorage, getUserTypeFromLocalStorage } from "./localstorage-helper";

export const findRouteAccess = (module: number) => {
    let userPermission:any = authStore.getAllPermission;
    let userRole: any = getUserTypeFromLocalStorage();
    // if(userRole != userTypeEnum[0]){
        if(JSON.stringify(userPermission) === "[]") {
            const permissions = localStorage.getItem('lizera_permissions'); 
            if(permissions)
                userPermission = JSON.parse(permissions);
        }
        let modulePermission = userPermission.filter((per:IRoleVM)=> per.ModuleType == module);
        if(modulePermission.length === 1)
            return (modulePermission[0].PermissionType == PermissionType.AllAccess || 
                modulePermission[0].PermissionType == PermissionType.ViewOnly)
        else
            return false;
    // }
    // else
    //     return true;
}

export const findModueOptionsExist = (moduleList: number[]) => {
    let userPermission:Array<IRoleVM> = authStore.getAllPermission;
    if(JSON.stringify(userPermission) === "[]") {
        const permissions = localStorage.getItem('lizera_permissions'); 
        if(permissions){
            userPermission = JSON.parse(permissions);
        }
    }
    const result = moduleList.some(module =>
        userPermission.some(permission => (permission.ModuleType === module && permission.PermissionType !== 2 ))
    );
    return result;
}

export const redirectToDefaultRoute = () => {
    let userType = getUserTypeFromLocalStorage();
    if(userType)
        if(userType ==  userTypeEnum[0])
            return RoutesConstants.HeadquarterManagement;
        else if(userType == userTypeEnum[1])
            return RoutesConstants.ReservationList;
        else if(userType == userTypeEnum[2])
            return RoutesConstants.ShiftManagement;
        else if(userType == userTypeEnum[3])
            return RoutesConstants.Dashboard;
        else if(userType == userTypeEnum[5])
            return RoutesConstants.Dashboard;
        else return RoutesConstants.PageNotFound;
    else if(getTokenFromLocalStorage() === "")
        return RoutesConstants.PageNotFound;
    else
        return RoutesConstants.PageNotFound;
}
  
// export const hucksterManagementRouteSetup = (module: number) => {
//     let isCameraActive = preferenceStore.getParkingLotCameraAccess.isAccessCameraActive;
//     let isPriceSchedulerActive  = preferenceStore.getPriceSchedulerAccess.isAccessPriceSchedulerActive;
//     let isTenantAccess: any = getIsTenantAccessFromLocalStorage();
//     if(ModuleType.BranchManagement == module || ModuleType.ParkingManagementList == module || ModuleType.MediaManagement == module || ModuleType.Integrator == module || ModuleType.SystemLog == module || ModuleType.UserLog == module || ModuleType.SoracomAuth == module || ModuleType.RouteGuidance == module || ModuleType.Downloads == module) {
//         return (isTenantAccess);
//     }
//     else if(ModuleType.CameraManagement == module){
//         return (isTenantAccess && isCameraActive);
//     }
//     else if(ModuleType.PriceSchedular == module){
//         return (isTenantAccess && isPriceSchedulerActive)
//     }
//     else if((ModuleType.HucksterUserManagement == module || ModuleType.CompanyUserManagement == module || ModuleType.TenantManagement == module) && isTenantAccess == true){
//         return false;
//     }
//     else {
//         return true;
//     }
// }